import type { SpApiOauthConnection } from '@/api/client';

export type VendorSetupStatus = 'pending' | 'syncing' | 'ready' | 'failed' | string;

export function vendorSetupStatus(conn: SpApiOauthConnection): VendorSetupStatus {
  return conn.setup_status || conn.enrollment?.status || 'pending';
}

export function vendorIsEnabled(conn: SpApiOauthConnection): boolean {
  if (typeof conn.is_enabled === 'boolean') return conn.is_enabled;
  return Boolean(conn.enrollment?.isEnabled);
}

export function vendorAlreadySynced(conn: SpApiOauthConnection): boolean {
  const status = vendorSetupStatus(conn);
  return status === 'ready' || Boolean(conn.enrollment?.alreadySynced);
}

export function vendorNeedsFirstSetup(conn: SpApiOauthConnection): boolean {
  const status = vendorSetupStatus(conn);
  return status !== 'ready' && status !== 'syncing' && !vendorAlreadySynced(conn);
}

export function vendorSetupStatusLabel(conn: SpApiOauthConnection): string {
  const status = vendorSetupStatus(conn);
  if (status === 'syncing') return 'Setting up…';
  if (status === 'failed') return 'Setup failed';
  if (vendorAlreadySynced(conn)) return 'Already synced';
  return 'Needs setup';
}

export function vendorSetupStatusClass(conn: SpApiOauthConnection): string {
  const status = vendorSetupStatus(conn);
  if (status === 'syncing') return 'text-brand';
  if (status === 'failed') return 'text-warning';
  if (vendorAlreadySynced(conn)) return 'text-foreground-subtle';
  return 'text-foreground-muted';
}
